import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { IFormBuilderAssistant } from '../../../shared/components/form-builder/form-builder-assistant/iform-builder-assistant.interface';
import { FormTemplateHtmlFieldsDesign_FormBuilderAssistant } from './form-builder-assistant';
import { Form } from '../../../shared/models/form-builder/form.model';
import { FormBuilderComponent } from '../../../shared/components/form-builder/form-builder.component';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { DesignComponent } from '../design/design.component';
import { environment } from '../../../../environments/environment.test';
import { AppComponent } from '../../../app.component';
import { HasUnsavedChanges } from '../../../route-guards/unsaved-changes.route-guard';
import { CurrentUserService } from '../../../security/current-user.service';
import { AlertDialogComponent, AlertDialogModel } from '../../../shared/dialogs/alert/alert-dialog.component';
import { FormErrorMessages } from '../../../shared/models/error-messages/form-error-messages';
import { FieldDefinition } from '../../../shared/models/form-builder/field-definition.model';
import { DataCollectionService } from '../../../shared/services/data-collection.service';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';
import { FormBuilderService } from '../../../shared/services/form-builder.service';
import { CachedFormFieldService } from '../../../shared/services/form-field-with-cache.service';

@Component({
    selector: 'app-design-form-html',
    //imports: [],
    templateUrl: './design-form-html.component.html',
    //styleUrl: './design-form-html.component.scss',
    styleUrls: ['./design-form-html.component.scss', '../design/design.component.scss'],
    standalone: false
})
export class DesignFormHtmlComponent extends DesignComponent {
    // Properties.
    //private form: Form;
    //private formBuilderAssistant: IFormBuilderAssistant = new FormTemplateHtmlFieldsDesign_FormBuilderAssistant();

    //@ViewChild('formBuilder') formBuilder: FormBuilderComponent;

    // Constructor.
    public constructor(route: ActivatedRoute,
        router: Router,
        formBuilderService: FormBuilderService,
        dataCollectionService: DataCollectionService,
        fieldDefinitionService: FieldDefinitionService,
        cachedFormFieldService: CachedFormFieldService,
        currentUserService: CurrentUserService,
        titleService: Title,
        public dialog: MatDialog,
        appComponent: AppComponent)
    {
        super(route, router, formBuilderService, dataCollectionService, fieldDefinitionService, cachedFormFieldService, currentUserService, titleService, dialog, appComponent);

        this.formBuilderAssistant = new FormTemplateHtmlFieldsDesign_FormBuilderAssistant();
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Get the form from the route.
        this.route.parent.data
            .subscribe((data: { currentSite: DataCollection }) => {
                //this.site = data.currentSite;

                this.route.data
                    .subscribe((data: { form: Form }) => {
                        this.form = data.form;

                        /*
                        if (this.form.id == 0) {
                            this.form.dataCollectionId = this.site.id;
                        }
                        */
                    });
            });

    }

    // Methods called by my HTML code.
    public get Form(): Form {
        return this.form;
    }

    public get FormBuilderAssistant(): IFormBuilderAssistant {
        return this.formBuilderAssistant;
    }

    // Handle control events.
    public saveForm(formBuilderParam: FormBuilderComponent): void {
        this.formBuilderService.save(formBuilderParam.form);
    }

    // Helper emthods.
}
